import {
  sendRequest,
  libInit,
  checkString,
} from '@html/_common/utils';

/* Q&A's for admins */
export default function AdminQuestions() {
  let isInitiated = false;
  let objectType = null;
  let objectId = null;
  let anotherFile = null;

  this.init = (params) => {
    ({ objectType } = params);
    ({ objectId } = params);

    /* admin */
    $('.ask-a').click((event) => {
      event.preventDefault();

      const askClass = 'ask';

      if (!isInitiated) {
        isInitiated = true;

        const $button = $(event.currentTarget);
        const oldText = $button.html();
        $button.html('<img class="l" src="/im/r/pw/tr-loader-small.gif">');

        sendRequest(
          '/api/popup/ask-question-admin',
          {},
          (data) => {
            if (data && data.status === 'OK') {
              $('main').append(data.popup);

              $('#ask_popup .dif').addClass('hid');
              $(`#ask_popup .dif.${askClass}`).removeClass('hid');

              $('#ask_popup_admin .but').click((submitEvent) => {
                submitEvent.preventDefault();

                this.askAdminSubmit();
              });

              $('#super_form_file').change((changeEvent) => {
                anotherFile = null;

                const { files } = changeEvent.target;
                if (files > 0) {
                  [anotherFile] = files;
                }
              });

              libInit('popup', () => {
                $('.ask_admin_link').magnificPopup({
                  closeOnBgClick: true,
                  callbacks: {
                    open: () => {
                      const $form = $('#ask_popup_admin .overlay');
                      $form.find('textarea, inout, select').val('');
                    },
                  },
                });

                $('.ask_admin_link_success').magnificPopup({
                  closeOnBgClick: true,
                });

                $('#ask_popup_admin_success .but').click((successEvent) => {
                  if (!$(successEvent.currentTarget).hasClass('blue')) {
                    successEvent.preventDefault();

                    $.magnificPopup.close();
                  }
                });

                $button.html(oldText);

                $('.ask_admin_link').click();
              });
            }
          },
        );
      } else {
        $('#ask_popup .dif').addClass('hid');
        $(`#ask_popup .dif.${askClass}`).removeClass('hid');

        $('.ask_admin_link').click();
      }
    });
  };

  /* submit the ask a question form ADMIN */
  this.askAdminSubmit = () => {
    const $form = $('#ask_popup_admin form');
    const comment = $.trim($form.find('#super_form_question').val());
    const answer = $.trim($form.find('#super_form_answer').val());
    const link = $.trim($form.find('#super_form_link').val());
    const email = $.trim($form.find('input[name="email"]').val());

    let error = false;
    if (!comment) {
      error = $form.find('#super_form_question').data('error');
    } else if ($form.find('input[name="email"]').length > 0 && (!email || !checkString(email, 'email'))) {
      error = $form.find('input[name="email"]').data('error');
    } else if (!answer) {
      error = $form.find('#super_form_answer').data('error');
    }

    if (error) {
      alert(error); // eslint-disable-line no-alert
    } else {
      const data = {
        question: comment,
        answer,
        link,
        email,
        object_type: objectType,
        object_id: objectId,
      };

      sendRequest($form.attr('action'), data, (responseData) => {
        if (responseData.status === 'OK') {
          if (anotherFile) {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `/faq/upload_file/${responseData.answer_id}`, true);
            xhr.setRequestHeader('X_FILENAME', anotherFile.name);
            xhr.onreadystatechange = () => {
              if (xhr.readyState === 4) {
                $('#ask_popup_admin_success .but.blue').attr('href', `/faq/question/${responseData.question.id}-${responseData.question.code}`);
                $('.ask_admin_link_success').click();
              }
            };

            xhr.send(this.another_file);
          } else {
            $('#ask_popup_admin_success .but.blue').attr('href', `/faq/question/${responseData.question.id}-${responseData.question.code}`);

            $('.ask_admin_link_success').click();
          }
        }
      });
    }
  };
}
